<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright text-center">
        &copy; 2020 Ingram Micro Inc. All Rigths reserved.
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
